/* src/app/components/product-qty/product-qty.component.scss */
ion-content {
  --padding-start: 10px;
  --padding-end: 10px;
  --padding-top: 10px;
  --padding-bottom: 10px;
}
.close {
  font-size: 14px !important;
  --padding-end: 0px;
}
img {
  height: 86px;
  width: 86px;
  padding-right: 10px;
  vertical-align: top;
}
p {
  font-size: 36px;
  margin: 0;
}
b {
  font-size: 20px;
}
span {
  font-size: 16px;
}
.spacing {
  margin: 32px 0px;
}
.no-break {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pattern-wrapper {
  display: inline-block;
  width: calc(100% - 100px);
  vertical-align: top;
}
.line-space {
  width: 80%;
  height: 1px;
  border: 1px gray solid;
  margin: 5px auto;
}
.wallet-info {
  background-color: #009acf;
  font-weight: bold;
  color: white;
  font-size: 16px;
  margin: 0 -5%;
}
.wallet-info .boxed-details {
  margin: auto;
  max-width: 50%;
  padding: 10px 0;
}
.wallet-info img {
  width: auto;
  max-height: 24px;
}
.line-show {
  white-space: nowrap;
}
.note {
  font-size: 14px;
  font-weight: lighter;
  color: gray;
  margin-bottom: 20px;
}
.show-se {
  display: none;
}
@media only screen and (max-width: 540px) {
  .wallet-info {
    font-size: 14px;
  }
  .wallet-info .boxed-details {
    max-width: 80% !important;
  }
  .hide-se {
    display: none;
  }
  .show-se {
    display: inline;
  }
  .title-se {
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
/*# sourceMappingURL=product-qty.component-3NH4KOY2.css.map */
